var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcYellowFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.95331 13.5284H17.0331C17.1664 13.5283 17.2972 13.4921 17.4111 13.4237C17.5249 13.3554 17.6175 13.2575 17.6786 13.1407C17.7397 13.024 17.7669 12.893 17.7574 12.7621C17.7479 12.6311 17.7019 12.5052 17.6245 12.3983L14.2921 7.80621L17.6245 3.21412C17.7019 3.10717 17.7479 2.98132 17.7574 2.85036C17.7669 2.7194 17.7397 2.58839 17.6786 2.47168C17.6175 2.35496 17.5249 2.25705 17.4111 2.18867C17.2972 2.12028 17.1664 2.08407 17.0331 2.08398H3.22665C3.03393 2.08398 2.84911 2.15934 2.71283 2.29348C2.57656 2.42763 2.5 2.60956 2.5 2.79926V18.5354C2.5 18.7251 2.57656 18.907 2.71283 19.0412C2.84911 19.1753 3.03393 19.2507 3.22665 19.2507C3.41937 19.2507 3.6042 19.1753 3.74047 19.0412C3.87675 18.907 3.95331 18.7251 3.95331 18.5354V13.5284Z",
    fill: "#FF8A5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcYellowFlag);
export default __webpack_public_path__ + "static/media/ic_yellow_flag.093df1d5e3a49fd99c4f2a96c2cb88ad.svg";
export { ForwardRef as ReactComponent };